import React, { useContext } from 'react';
import { IOptimisationResult } from './OptimizeResult';
import { InputTypes } from '../OptimizePlanModal/OptimizePlanTable/OptimizeTableContent';
import dayjs from 'dayjs';
import { UserContext } from 'contexts/ConfigContext';
import { formatNumWithKMBAlt, getConfig } from 'utils/helperMethods';

interface IProps {
    data: IOptimisationResult;
}
const BaseInputConstraintSection: React.FC<IProps> = ({ data }) => {
    const { constraints, base_input } = data;
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const { decimalForPercentage, decimalForNonPercentage } = commonConfig ?? {};
    return (
        <div className="py-6 px-8 bg-backgroundGreyAlt rounded-lg mb-3">
            <div className="text-fontGreyAlt mb-1">Base Inputs</div>
            <div className="grid grid-cols-2 gap-x-4 px-4 mb-4">
                <div className="flex gap-1">
                    <span className="text-blackTransparent88">Objective:</span>
                    <span className="text-greyFont">{base_input.objective}</span>
                </div>
                <div className="flex gap-1">
                    <span className="text-blackTransparent88">Start Date:</span>
                    <span className="text-greyFont">
                        {dayjs((base_input.start_date as number) * 1000).format('MM/DD/YYYY')}
                    </span>
                </div>
            </div>
            <div className="text-fontGreyAlt mb-1">Constraints</div>
            <div className="grid grid-cols-2 grid-rows-3 gap-y-3 gap-x-4 px-4">
                {!!constraints[1]
                    ? constraints.slice(1).map((item) => {
                          const { label, type, max_value, min_value, single_value, name } = item;
                          const isPercentage = label?.includes('%');
                          const decimalType = isPercentage ? decimalForPercentage : decimalForNonPercentage;
                          return (
                              <div key={name} className="flex gap-1">
                                  <span className="text-blackTransparent88">{label}:</span>
                                  {type === InputTypes.Range ? (
                                      <div className="text-greyFont">
                                          <span>{formatNumWithKMBAlt(min_value ?? 0, decimalType)}</span> {'-'}{' '}
                                          <span>{formatNumWithKMBAlt(max_value ?? 0, decimalType)}</span>
                                      </div>
                                  ) : (
                                      <span className="text-greyFont">{single_value}</span>
                                  )}
                              </div>
                          );
                      })
                    : 'NA'}
            </div>
        </div>
    );
};

export default BaseInputConstraintSection;
